var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelefoneIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_599_107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9583 0.916519H5.04167C3.70498 0.917975 2.42346 1.44962 1.47828 2.3948C0.533097 3.33998 0.00145582 4.6215 0 5.95819L0 16.0415C0.00145582 17.3782 0.533097 18.6597 1.47828 19.6049C2.42346 20.5501 3.70498 21.0817 5.04167 21.0832H16.9583C18.295 21.0817 19.5765 20.5501 20.5217 19.6049C21.4669 18.6597 21.9985 17.3782 22 16.0415V5.95819C21.9985 4.6215 21.4669 3.33998 20.5217 2.3948C19.5765 1.44962 18.295 0.917975 16.9583 0.916519ZM16.9583 3.66652C17.5143 3.66837 18.0502 3.87419 18.4644 4.24494L12.5061 10.2033C12.1014 10.5898 11.5633 10.8055 11.0037 10.8055C10.444 10.8055 9.90594 10.5898 9.50125 10.2033L3.54292 4.24494C3.95528 3.87586 4.48827 3.67016 5.04167 3.66652H16.9583ZM16.9583 18.3332H5.04167C4.43388 18.3332 3.85098 18.0917 3.42121 17.662C2.99144 17.2322 2.75 16.6493 2.75 16.0415V7.34877L7.55242 12.1512C8.00503 12.604 8.54242 12.9632 9.13389 13.2083C9.72536 13.4533 10.3593 13.5795 10.9995 13.5795C11.6398 13.5795 12.2737 13.4533 12.8652 13.2083C13.4567 12.9632 13.9941 12.604 14.4467 12.1512L19.25 7.34877V16.0415C19.25 16.6493 19.0086 17.2322 18.5788 17.662C18.149 18.0917 17.5661 18.3332 16.9583 18.3332Z",
    fill: "#881C15"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_599_107"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelefoneIcon);
export default __webpack_public_path__ + "static/media/telefone_icon.980a782f0916c0c718e4800241a67223.svg";
export { ForwardRef as ReactComponent };